export const PRELOADER_ACTIVE = 'PRELOADER_ACTIVE';
export const BTN_LOADER = 'BTN_LOADER';

// Store

export interface StatePreloader {
    preloader: object[];
    btnloader: boolean;
}
